import { View, StyleSheet } from "react-native";
import React, { useEffect, useMemo, useState } from "react";
import {
  CheckBox,
  Divider,
  IndexPath,
  Modal,
  Select,
  SelectItem,
  Text,
} from "@ui-kitten/components";
import Button from "components/Button";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { LIGHT_BLUE } from "constants/";
import { sortByItems } from "screens/SeatSelection/types";
import { FiltersInterface } from "../types";
import FilterIcon from "components/FilterIcon";
import { BestTicketBlockDetails } from "features/types";
interface Props {
  filters: FiltersInterface;
  onApply: (filters: FiltersInterface) => void;
  bestBlocks: BestTicketBlockDetails[];
}

const Filters: React.FC<Props> = (props) => {
  const { filters, onApply, bestBlocks } = props;

  const [visible, setVisible] = useState(false);
  const [showPremium, setShowPremium] = useState(false);
  const [showAccessible, setShowAccessible] = useState(false);

  // find the initial selected index for the Select component
  const [selectedIndex, setSelectedIndex] = useState(
    new IndexPath(sortByItems.findIndex((item) => item === filters.sortBy))
  );

  const hasBothPremiumAndNonPremiumSeats = useMemo(() => {
    if (bestBlocks.length === 0) return false;
    return (
      // has premiumn seats
      bestBlocks.some((block) => Number(block.perTicketCharge) > 0) &&
      // has non-premium seats
      bestBlocks.some((block) => Number(block.perTicketCharge) === 0)
    );
  }, [bestBlocks]);

  useEffect(() => {
    setShowAccessible(filters.showAccessible);
    setShowPremium(filters.showPremium);
  }, []);

  return (
    <>
      <FilterIcon onPress={() => setVisible(true)} />

      <Modal
        visible={visible}
        backdropStyle={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
      >
        <View
          style={{
            backgroundColor: "white",
            padding: 15,
            zIndex: 99,
          }}
        >
          <Text category="s1">Filter By</Text>
          <View style={{ marginTop: 5 }}>
            <CheckBox
              onChange={() => setShowAccessible(!showAccessible)}
              checked={showAccessible}
            >
              {() => (
                <Text style={styles.filterText}>
                  Show Accessible Options{" "}
                  <MaterialCommunityIcons
                    name="wheelchair-accessibility"
                    color={LIGHT_BLUE}
                    size={24}
                  ></MaterialCommunityIcons>
                </Text>
              )}
            </CheckBox>

            {/* only show the premium seat check box if there are both premium and non premium seats */}
            {hasBothPremiumAndNonPremiumSeats && (
              <CheckBox
                onChange={() => setShowPremium(!showPremium)}
                checked={showPremium}
              >
                {() => (
                  <Text style={styles.filterText}>Show Premium Seats</Text>
                )}
              </CheckBox>
            )}
          </View>
          <Divider style={{ marginVertical: 5 }} />
          <Text category="s1">Sort By</Text>
          <View style={{ marginTop: 5 }}>
            <Select
              value={sortByItems[selectedIndex.row]}
              selectedIndex={selectedIndex}
              onSelect={(index) => {
                setSelectedIndex(index as IndexPath);
              }}
            >
              {sortByItems.map((item) => (
                <SelectItem title={item} key={item}></SelectItem>
              ))}
            </Select>
          </View>
          <Button
            style={{ alignSelf: "flex-end", marginTop: 10 }}
            size="small"
            onPress={() => {
              onApply({
                showAccessible,
                showPremium,
                sortBy: sortByItems[selectedIndex.row],
              });
              setVisible(false);
            }}
          >
            APPLY
          </Button>
        </View>
      </Modal>
    </>
  );
};

const styles = StyleSheet.create({
  filterText: {
    fontSize: 16,
    fontWeight: "500",
    marginLeft: 5,
  },
});

export default Filters;
